import StyledContainer from "style/styledContainer"
import styled from "styled-components"
import { Row, RowCenter } from "style/preset";
import EthImg from 'assets/images/ETH.png'
import ImgCom from "./ImgCom";

import { NumberInput } from "./PayNumberCom";
import { getIconUrl } from "utils";
import { useAppSelector } from "hooks/redux/hooks";
import CImage from "./CImage";

const ReceiveCom = () => {
    const { toChain, toToken, toAmount, toAmountUsdt} = useAppSelector((state) => state.coreInfo)

    return <PayNumberContentWrap>
            <Row $mb="3px" $justifyContent="space-between">
                <StyledContainer $fontSize="14px" $lineHeight="16px">You will receive</StyledContainer>
            </Row>
            <Row $justifyContent="space-between">
                <ReceiveValWrap>
                    <NumberInput disabled={true} value={toAmount} thousandSeparator=","></NumberInput>
                    <StyledContainer $ml="6px" $fontWeight4 $roobertRegular>{toToken?.symbol}</StyledContainer>
                </ReceiveValWrap>

               <ImgCom imgUrl={getIconUrl(toToken?.index, toToken?.symbol)}></ImgCom>
            </Row>
            <Row $mt="7px">
                <InfoWrap $pl="30px !important">
                    <CImage width="22px" height="22px" position="absolute" left="0" top="0"  src={getIconUrl(toChain?.chainIndex, 'chain', 'solid')}></CImage>
                    On {toChain?.fullName}
                </InfoWrap>
                <InfoWrap $ml="6px">
                    ${toAmountUsdt}
                </InfoWrap>
            </Row>
        </PayNumberContentWrap>
}

const PayNumberContentWrap = styled(StyledContainer)`
    padding: 10px 0 10px 20px;
    border-left: 1px dashed #B5B7BA;
`

const ReceiveValWrap = styled(RowCenter)`
    font-family: RoobertSemiBold;
    font-size: 30px;
    font-weight: 600;
    line-height: 1;
    margin-right: 10px;
    flex: 1;
`

const InfoWrap = styled(RowCenter)`
    font-size: 12px;
    line-height: 14px;
    padding: 4px 6px;
    position: relative;
    background-color: #F4F5F5;
    border-radius: 4px;
`

export default ReceiveCom